import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Typography,
    Box,
    Button,
    IconButton,
    Tooltip,
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { grey } from '@mui/material/colors';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Delete, Edit } from '@mui/icons-material';

const TablaProyectos = ({ columnas, lineas, handleOpen, acciones = false, }) => {
    const [data, setData] = React.useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 5
    });

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    //abrir modal
    const openModal = (row) => {
        var id = row.original.id
        console.log(id)
        handleOpen(id)
    }

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                columns={columns}
                data={data}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.background.default, 0.1),
                        maxWidth: '1000px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                enableColumnResizing
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderTopToolbarCustomActions={() => (
                    <>
                        <Tooltip arrow placement="right" title="Crear proyecto de investigación">
                            <Button
                                variant="contained"
                                color='secondary'
                                onClick={() => handleOpen()}
                            >
                                <PlaylistAddIcon />
                            </Button>
                        </Tooltip>
                        {/* <Typography variant="subtitle1" component="h2" sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                            {titulo}
                        </Typography> */}
                    </>
                )}
            />
        </>
    )
}

export default TablaProyectos